/**
 * CustomModal.js
 * Written by: Alex Kasemir
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@minerva-analytics/pantheon';

import {
  CustomModalCont,
  ModalHeaderText,
  ModalHeader,
  CloseButton,
  AllSetCircle,
  HeaderTextAndImg,
  ErrorCircle,
} from './CustomModal.styles';

const CustomModal = ({ onCancel, body, header, hideCloseButton }) => {
  const headerText = header && header.text ? header.text : ``;
  return (
    <CustomModalCont>
      <ModalHeader>
        <HeaderTextAndImg>
          { header && header.img ? header.error ? <ErrorCircle /> : <AllSetCircle /> : null }
          <ModalHeaderText>
            { typeof header === `string` ? header : headerText }
          </ModalHeaderText>
        </HeaderTextAndImg>
        <CloseButton onClick={ onCancel } />
      </ModalHeader>
      {body}
      {!hideCloseButton
        ? <Button onClick={onCancel} type="secondary">Close</Button>
        : null
      }
    </CustomModalCont>
  );
};

CustomModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  body: PropTypes.any.isRequired,
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  hideCloseButton: PropTypes.bool,
};

CustomModal.defaultProps = {
  hideCloseButton: true,
};

export default CustomModal;
